import { useStaticQuery, graphql } from "gatsby";
import React, { useState } from "react";
import Galleries1 from "../gallery/Galleries1";

const ProjectList = ({ images = [], tabIndex }) => {
  return <Galleries1 tabIndex={tabIndex} data={images} />;
};

function ProjectStatusContent() {
  const data = useStaticQuery(graphql`
    {
      allOngoingJson(
        filter: { is_active: { eq: true } }
        sort: { order: DESC, fields: id }
      ) {
        edges {
          node {
            title
            sections {
              title
              project_updates {
                title
                images {
                  childImageSharp {
                    fluid(maxWidth: 600, quality: 70) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                videos {
                  type
                  thumbnail {
                    childImageSharp {
                      fluid(maxWidth: 600, quality: 70) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                  link
                }
              }
            }
          }
        }
      }

      commercialOngoingJson(slug: { eq: "promenade-commercial-guindy-chennai" }) {
        id
        is_active
        is_custom
        ribbon_text
        title
        slug
        rera
        tagline
        banner {
          childImageSharp {
            fluid(maxWidth: 600, quality: 70) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        brouchureUrl
        callUsNumber
        video {
          type
          link
        }
        short_desc
        footer_desc
        sections {
          title
          gallery {
            title
            images {
              childImageSharp {
                fluid(maxWidth: 600, quality: 70) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          project_updates {
            title
            images {
              childImageSharp {
                fluid(maxWidth: 600, quality: 70) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            videos {
              type
              thumbnail {
                childImageSharp {
                  fluid(maxWidth: 600, quality: 70) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              link
            }
          }
        }
      }
    }
  `);

  const images = [];
  const commercialImages = [];
  const [tabIndex, setTabIndex] = useState(0);

  data.allOngoingJson.edges.forEach(({ node }) => {
    node.sections.forEach((item) => {
      if (Array.isArray(item.project_updates)) {
        images.push({
          title: `${node.title}${item.title ? ` - ${item.title}` : ""}`,
          gallery: item.project_updates,
        });
      }
    });
  });

  data.commercialOngoingJson.sections.forEach((item) => {
    if (Array.isArray(item.project_updates)) {
      commercialImages.push({
        title: `${item.title}`,
        gallery: item.project_updates,
      });
    }
  });

  return (
    <section className="residence-section">
      <div className="container">
        <div className="custom-tab-menu">
          <span
            className={`${tabIndex === 0 ? "active" : ""}`}
            onClick={() => setTabIndex(0)}
          >
            Residential
          </span>
          <span
            className={`${tabIndex === 1 ? "active" : ""}`}
            onClick={() => setTabIndex(1)}
          >
            Commercial
          </span>
        </div>
        {tabIndex === 0 ? (
          <div className="pb-4" id="synopsis">
            <h5 className="residence-section-title" id="synopsis">
              Residential Ongoing Projects
            </h5>
            {/* <ProjectList tabIndex={tabIndex} images={images} /> */}
            <ProjectList tabIndex={tabIndex} images={images} showYearTabs />

          </div>
        ) : (
          <div className="pb-4" id="synopsis">
            <h5 className="residence-section-title" id="synopsis">
              Commercial Ongoing Projects
            </h5>
            <ProjectList tabIndex={tabIndex} images={commercialImages} />
            
          </div>
        )}
      </div>
    </section>
  );
}

export default ProjectStatusContent;
